import { useSetRecoilState } from 'recoil';
import { useCallback } from 'react';

import { SnackbarAtom } from 'atoms/snackbar';

/**
 * Hook to use snackbar notifications
 * @param { int|null } duration - time to show snackbar. If null - shown until close
 * @returns {{ errorNotification: function, successNotification: function, warningNotification: function }}
 */
export function useNotification(duration = 7000) {
  const setSnackbar = useSetRecoilState(SnackbarAtom);
  const errorNotification = useCallback(
    message => {
      if (message) {
        setSnackbar({ message, severity: 'error', duration });
      }
    },
    [setSnackbar, duration],
  );
  const successNotification = useCallback(
    message => {
      if (message) {
        setSnackbar({ message, severity: 'success', duration });
      }
    },
    [setSnackbar, duration],
  );
  const warningNotification = useCallback(
    message => {
      if (message) {
        setSnackbar({ message, severity: 'warning', duration });
      }
    },
    [setSnackbar, duration],
  );

  return { errorNotification, successNotification, warningNotification };
}
